import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  submitForm(event) {
    event.preventDefault();

    // get the main form and submit it directly
    const mainForm = document.getElementById('product-form');

    if (mainForm) {
      mainForm.requestSubmit();
    }
  }
}
